import { Component, Input } from '@angular/core';
import { EdiDispatchProductMapped } from '../edi-dispatch-parcel-management/edi-dispatch-parcel-management.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-edi-dispatch-edit-parcel-product-modal',
  templateUrl: './edi-dispatch-edit-parcel-product-modal.component.html',
  styleUrl: './edi-dispatch-edit-parcel-product-modal.component.scss',
  standalone: false
})
export class EdiDispatchEditParcelProductModalComponent {
  @Input() parcelProduct: EdiDispatchProductMapped;

  isEdit: boolean = false;

  constructor(
    protected activeModal: NgbActiveModal
  ) {}

  save(): void {
    this.activeModal.close(this.parcelProduct);
  }
}
